var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conference_main_box"},[_c('meetingPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }